import parse from "html-react-parser";
import { sortBy } from "lodash";
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import GratefulDB from "../../GratefulDB";
import GratefulDBContext from "../../GratefulDBContext";
import { useNavUtils } from "../shared/useNavUtils";
import "./Chords.scss";

const Chords: React.FC = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const SBD = require(`../../images/${process.env.REACT_APP_SBD_IMAGE}`);

  const params = useParams();
  const navUtils = useNavUtils();
  const gratefulDB = useContext<GratefulDB>(GratefulDBContext);

  const chords = params.id ? gratefulDB.getChords(params.id) : null;
  const chordsByLetter = !params.id ? gratefulDB.getChordsByLetter() : null;
  const sortedLetters = chordsByLetter
    ? sortBy(Object.keys(chordsByLetter))
    : null;

  return (
    <div className="ui container Chords">
      <h2 className="ui header chords-header">
        <i className="music icon" />
        <div className="content">
          {process.env.REACT_APP_GRATEFUL_CHORDS_NAME == "gratefulchords" &&
          params.id ? (
            <button
              className="right floated ui teal basic button"
              onClick={() =>
                window.location.assign(
                  `https://rukind.com/gdpedia/titles/view/${params.id}`
                )
              }
            >
              View on
              <br />
              <b>RuKind</b>
            </button>
          ) : null}
          <div className="header">
            {!params.id
              ? process.env.REACT_APP_CHORDS_SOURCE
              : chords
              ? chords.title
              : null}
          </div>
          <div className="sub header">
            {!params.id
              ? "Our intent is all for your delight."
              : chords
              ? chords.artist
              : null}
          </div>
        </div>
      </h2>
      <div className="ui divider" />
      {params.id ? (
        <div className="chords-wrapper">
          {chords ? parse(chords.html) : null}
        </div>
      ) : (
        <div className="ui divided relaxed items">
          {sortedLetters
            ? sortedLetters.map((letter) => (
                <div key={letter} className="item">
                  <div className="ui tiny image mobile-hidden">
                    <img src={SBD} />
                  </div>
                  <div className="middle aligned content">
                    <span className="header">
                      {chordsByLetter
                        ? chordsByLetter[letter].map((entry) => (
                            <a
                              className="entry"
                              onClick={() => navUtils.chords(entry.identifier)}
                              key={entry.identifier}
                            >
                              {entry.title}
                            </a>
                          ))
                        : null}
                    </span>
                  </div>
                </div>
              ))
            : null}
        </div>
      )}
    </div>
  );
};

export default Chords;
